import { Client, Conversation, Participant, Message, User } from "@twilio/conversations";
import { GenericThemeShape } from "@twilio-paste/theme";
import { AlertVariants } from "@twilio-paste/core/alert";
import { PasteCustomCSS } from "@twilio-paste/core/customization";

import {
    FileAttachmentConfig,
    TranscriptConfig,
    PreEngagementConfig,
    ResumeSessionConfig,
    SessionPreEngagementData
} from "../definitions";

export enum EngagementPhase {
    PreEngagementForm = "PreEngagementForm",
    MessagingCanvas = "MessagingCanvas",
    Loading = "Loading"
}

export type ChatState = {
    conversationsClient?: Client;
    conversation?: Conversation;
    participants?: Participant[];
    users?: User[];
    messages?: Message[];
    attachedFiles?: File[];
    conversationState?: string;
};

export type PreEngagementData = { [key: string]: any };

export type SessionState = {
    currentPhase: EngagementPhase;
    expanded: boolean;
    token?: string;
    conversationSid?: string;
    conversationsClient?: Client;
    conversation?: Conversation;
    users?: User[];
    participants?: Participant[];
    messages?: Message[];
    conversationState?: "active" | "inactive" | "closed";
    preEngagementData?: PreEngagementData;
    sessionPreEngagementData?: SessionPreEngagementData;
    error: string;
};

export type ConfigState = {
    serverUrl?: string;
    expanded?: boolean;
    theme?: {
        isLight?: boolean;
        overrides?: Partial<GenericThemeShape> | any;
        elements?: {
            [key: string]: PasteCustomCSS;
        };
    };
    fileAttachment?: FileAttachmentConfig;
    transcript?: TranscriptConfig;
    resumeSessionConfig?: ResumeSessionConfig;
    preEngagementConfig?: PreEngagementConfig;
    context?: { [key: string]: string };
    componentProps?: { [key: string]: any };
};

export type Notification = {
    dismissible: boolean;
    id: string;
    onDismiss?: () => void;
    message: string;
    timeout?: number;
    type: AlertVariants;
};

export type NotificationState = Notification[];

export type AppState = {
    chat: ChatState;
    config: ConfigState;
    session: SessionState;
    notifications: NotificationState;
};

export type WebchatEventListenerCallback = ({
    conversationsClient,
    conversation
}: {
    conversationsClient?: Client;
    conversation?: Conversation;
}) => void | Promise<void>;

type WebchatEventListener = {
    [key: string]: WebchatEventListenerCallback;
};

export type WebchatEventListenerState = {
    listeners: WebchatEventListener[];
};
